import colors from '@nykaa/ui-components/tokens/colors';
import { hexToRgb } from '@nykaa/ui-components/styles/utils';

export const config = {
  colors: {
    /* Brand / Primary */
    primary: colors.snow100,
    primary10: colors.snow200,
    primary20: colors.snow300,
    primary30: colors.snow400,
    primary40: colors.snow500,
    primary50: colors.snow600,

    /* Surface */
    surface: colors.black100,
    surface10: colors.black600,
    surface20: colors.black500,
    surface30: colors.black400,
    surface40: colors.black300,
    surface50: colors.black200,

    /* Secondary */
    secondary: colors.snow100,
    secondary10: colors.snow200,
    secondary20: colors.snow300,
    secondary30: colors.snow400,
    secondary40: colors.snow500,
    secondary50: colors.snow600,

    /* Inverse (light equivalents) */
    inverse: colors.snow100,
    inverse10: colors.snow200,
    inverse20: colors.snow300,
    inverse30: colors.snow400,
    inverse40: colors.snow500,
    inverse50: colors.snow600,

    /* States (on dark surface) */
    stateHover: hexToRgb(colors.snow100, 0.08),
    statePressed: hexToRgb(colors.snow100, 0.16),
    stateDisabled: hexToRgb(colors.snow100, 0.36),

    /* Text */
    textPrimary: colors.snow100,
    textSecondary: hexToRgb(colors.snow100, 0.72),
    textOutline: hexToRgb(colors.snow100, 0.16),
    textDecorative: hexToRgb(colors.snow100, 0.08),
    textDisabled: colors.snow600,
    textInversePrimary: colors.black100,

    /* Info */
    infoPrimary: colors.blue500,
    info10: colors.blue900,
    pdpTagColor: '#BF950A',
    infoOpacity8: hexToRgb(colors.blue500, 0.08),
    infoOpacity16: hexToRgb(colors.blue500, 0.16),

    /* positive */
    // positive: "#4FC668",
    positivePrimary: colors.green500,
    positive10: colors.green50,
    positiveOpacity8: hexToRgb(colors.green500, 0.08),
    positiveOpacity16: hexToRgb(colors.green500, 0.16),

    /* negative */
    negativePrimary: colors.red600,
    negative10: colors.red50,
    negativeOpacity8: hexToRgb(colors.red600, 0.08),
    negativeOpacity16: hexToRgb(colors.red600, 0.16),

    /* warning */
    warningPrimary: colors.orange500,
    warning10: colors.orange50,
    warningOpacity8: hexToRgb(colors.orange600, 0.08),
    warningOpacity16: hexToRgb(colors.orange600, 0.16),

    /* Surface Inverse (for light cards inside dark UI) */
    surfaceInverse: colors.snow100,
    surfaceInverse10: colors.snow200,
    surfaceInverse20: colors.snow300,
    surfaceInverse30: colors.snow500,
    surfaceInverse40: colors.snow600,
    surfaceInverse50: colors.snow900,

    secondaryInverse: '#A61C54',

    /* Misc */
    state: colors.black500,
    menuItemHover: colors.snow100,
    viewBagColor: colors.black100,

    /* HNM Tabs */
    hnmTabActiveColor: '#FF4D4F',
    hnmTabInactiveColor: colors.snow500,

    filterSurface: hexToRgb(colors.black100, 0.75),
    filterHover: 'transparent',
    filterSelected: colors.black400,
    filterBackdropFilter: '20',
    reviewTagBackground: colors.black200,
    searchTextColor: hexToRgb(colors.pebble800, 0.72),
    searchBgColor: colors.snow600,
    searchSectionBgColor: 'transparent',
    searchTermBorderColor: hexToRgb(colors.snow100, 0.16),
    suggestionIconColor: hexToRgb(colors.snow100, 0.72),
    overlayBg: '#242627',
    brandbookTagBg: colors.black400,
    brandbookBrandTagBg: '#6F7981',
    brandbookBrandTagTextColor: colors.black100,
    brandReviewBg: colors.black300,
    brandReviewTag: colors.black400,
    wishlistIconBg: hexToRgb(colors.black100, 0.44),
    mwebFilterBg: colors.black100,
    mwebFilterSelected: '#242627',
    sizeSelected: hexToRgb(colors.snow100, 0.16),
    ratingBg: colors.black200,
    subtextColor: hexToRgb(colors.snow100, 0.72),
    sizeGuideColor1: colors.black200,
    sizeGuideBorder: hexToRgb(colors.snow100, 0.16),
    sizeGuidePillBg: '#242627',
    sizeGuideToggleBg: colors.black200,
    sizeGuideToggleOutline: hexToRgb(colors.snow100, 0.16),
    pdpCouponsSectionBg: "#262B2F",
    pdpCouponBgImgOpacity: 0.24,
    pdpCavSectionBg: "#262B2F",
    filterInputBg: colors.black500,
    eddInputBg: colors.black400,
    eddInputFocus: colors.black400,
    responsibleTagBg: '#4FC66829',
    shimmerBg: colors.black300,
    wishlistNudge: colors.snow100,
    brand_primary: colors.snow100,
    sectionBg: colors.black100,
    copyrightBg: colors.black200,
    modelDetailsBg: "#262B2F",
    modelDetailsBorder: "transparent",
    modelDetailsCardBg: "#3A4047",
    modelDetailsSecondCardBg: "#3A4047",
  },
  borders: {
    buttonBorderRadius: '99px',
    mwebButtonBorderRadius: '99px',
  },
  typography: {},
};
